import { PaymentType } from '@repo/shared/components'
import { type FlatAsset } from './order-box.types'
import { type MessagesKeys, useTranslate } from '@repo/shared/hooks'
import {
  AspectRatio,
  Badge,
  Col,
  DeltaBadge,
  Row,
  Typography,
} from '@repo/ui/components'
import Image from 'next/image'

interface IOrderBoxAssetSelectItemProps {
  onClick: () => void
  //TODO separate for each app
  asset: FlatAsset
}

export const OrderBoxAssetSelectItem = (
  props: IOrderBoxAssetSelectItemProps,
) => {
  const { onClick, asset } = props
  const { t } = useTranslate()

  const statusBadgeConfigs: Record<
    string,
    {
      color: 'positive' | 'alert' | 'disabled'
      variant: 'solid' | 'liquid'
    }
  > = {
    coming_soon: {
      color: 'positive',
      variant: 'solid',
    },
    suspended: {
      color: 'alert',
      variant: 'liquid',
    },
    delisting: {
      color: 'disabled',
      variant: 'liquid',
    },
    off_market: {
      color: 'alert',
      variant: 'liquid',
    },
  }

  return (
    <div className='hover:bg-neutral-surface-5 cursor-pointer transition-colors duration-300'>
      <Row
        className='p-xs gap-md flex flex-row items-center w-full border-b border-neutral-surface-5 last:border-none cursor-pointer'
        onClick={onClick}
      >
        <div className='w-3xl'>
          <AspectRatio className=' aspect-1/1'>
            <Image
              src={asset.image || '/images/placeholder.webp'}
              alt='Photo of property'
              fill
              sizes='(max-width: 768px) 100vw, 32px'
              className='h-full w-full  rounded-2xs object-cover'
              loading='lazy'
            />
          </AspectRatio>
        </div>

        <div className='gap-xs flex w-full flex-col'>
          {asset.name && (
            <Row className='gap-2xs'>
              <Typography
                size='sm'
                color='text-neutral-surface-100'
                className='text-start'
              >
                {asset.name}{' '}
                {asset.tradeStatus && asset.tradeStatus !== 'active' && (
                  <Badge
                    size='sm'
                    variant={statusBadgeConfigs[asset.tradeStatus]?.variant}
                    color={statusBadgeConfigs[asset.tradeStatus]?.color}
                  >
                    {t(
                      `common_project_trade_status_${asset.tradeStatus}` as MessagesKeys,
                    )}
                  </Badge>
                )}
              </Typography>
            </Row>
          )}
          <Row>
            <Col className='gap-sm'>
              <Row className='gap-xs'>
                {asset.state && (
                  <Badge
                    size='md'
                    variant='text'
                    color='neutral'
                    className='text-neutral-surface-60'
                  >
                    {t(`common_${asset.state}` as MessagesKeys)}
                  </Badge>
                )}

                {asset.token && (
                  <Typography
                    size='xs'
                    color='text-neutral-surface-60'
                    className='text-start font-[AzarMehr]'
                  >
                    {asset.token}
                  </Typography>
                )}
              </Row>
              <Row className='gap-xs'>
                {asset?.province && (
                  <Typography size='xs' color='text-neutral-surface-60'>
                    {asset?.province}
                  </Typography>
                )}
                {asset?.district && (
                  <Typography size='xs' color='text-neutral-surface-60'>
                    {asset?.district}
                  </Typography>
                )}
                {asset.type && (
                  <Typography size='xs' color='text-neutral-surface-60'>
                    {t(`filters_usage_${asset.type}` as MessagesKeys)}
                  </Typography>
                )}
              </Row>
            </Col>
            <Col className='justify-end gap-2xs  w-fit  items-end  '>
              <DeltaBadge
                variant='ghost'
                size='lg'
                value={+(asset.percentChange || 0)}
              />
              <Row className='gap-2xs w-fit'>
                {/* <Typography size='sm' color='text-neutral-surface-60'>
                {t('projectsPage_price_per_meter')}
              </Typography> */}
                <PaymentType
                  value={+(asset.pricePerMeter || 0)}
                  size='2xs'
                  numberSize='sm'
                  isBold={false}
                />
              </Row>
            </Col>
          </Row>
        </div>
      </Row>
    </div>
  )
}
